module.exports = __webpack_public_path__ + "img/report_graphBPJS.1dbde4f1.svg";